<template>
  <v-dialog
    v-model="dialog"
    persistent
    transition="dialog-bottom-transition"
    max-width="1000"
  >
    <div class="bg-white poppins">
      <div class="modal-header py-4 align-center">
        <h4 class="mb-0 font-weight-bolder"></h4>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <v-card-text class="pt-6">
        <form id="createForm" class="pa-3 pb-0">
          <v-text-field
            v-model.trim="$v.formData.supplier.$model"
            :error-messages="validateState('supplier') ? errorMessages : ''"
            label="Supplier"
            clearable
            dense
            outlined
          ></v-text-field>
          <v-text-field
            v-model.trim="$v.formData.system_code.$model"
            :error-messages="validateState('system_code') ? errorMessages : ''"
            label="System_code"
            clearable
            dense
            outlined
          ></v-text-field>
          <v-main class="text-center mt-4">
            <v-btn class="mr-4" color="primary" @click="submitForm">
              submit
            </v-btn>
            <v-btn @click="resetForm"> clear </v-btn>
          </v-main>
        </form>
      </v-card-text>
      <div style="flex: 1 1 auto"></div>
    </div>
    <!--begin::Modal dialog-->
    <div class="bg-white poppins">
      <!--begin::Modal header-->
      <div class="modal-header py-4 align-center">
        <h4 class="mb-0 font-weight-bolder">Edit Supplier</h4>
        <!--begin::Close-->
        <div
          class="btn btn-sm btn-icon btn-active-light-info"
          @click="dialog = false"
        >
          <span class="svg-icon">
            <v-icon size="22">mdi-close</v-icon>
          </span>
        </div>
        <!--end::Close-->
      </div>
      <!--end::Modal header-->
      <!--begin::Modal body-->
      <div
        class="modal-body d-flex flex-column h-550px scroll-y mx-5 mx-xl-15 py-7"
      >
        <!--begin::Body-->

        <form id="createForm" class="pa-3 pb-0">
          <v-text-field
            v-model.trim="$v.formData.supplier.$model"
            :error-messages="validateState('supplier') ? errorMessages : ''"
            label="Supplier"
            clearable
            dense
            outlined
          ></v-text-field>
          <v-text-field
            v-model.trim="$v.formData.system_code.$model"
            :error-messages="validateState('system_code') ? errorMessages : ''"
            label="System_code"
            clearable
            dense
            outlined
          ></v-text-field>
        </form>
        <!--end::Body-->

        <!--begin::Actions-->
        <div class="mb-4 d-flex flex-grow-1 align-end justify-center">
          <button
            type="reset"
            class="btn btn-light mr-3 px-5 py-3 ls1"
            @click="resetForm"
          >
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-info px-5 py-3 ls1"
            @click="submitForm"
          >
            Submit
          </button>
        </div>
        <!--end::Actions-->
      </div>
      <!--end::Modal body-->
    </div>
    <!--end::Modal dialog-->
  </v-dialog>
</template>

<script>
import Apiservice from "@/core/services/api.service";
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import Swal from "sweetalert2";

export default {
  mixins: [validationMixin],
  validations: {
    formData: {
      supplier: { required, maxLength: maxLength(40) },
      system_code: { required, maxLength: maxLength(40) },
    },
  },
  name: "EditItem",
  props: ["refresher", "loader", "integration_id", "itemForAction"],
  data: () => ({
    dialog: false,
    formData: {
      supplier_id: null,
      supplier: null,
      system_code: null,
    },
    errorMessages: ["This Field is required"],
  }),
  methods: {
    toggleModal() {
      this.resetForm();
      this.dialog = !this.dialog;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.formData[name];
      return $dirty ? $error : null;
    },
    submitForm() {
      this.$v.formData.$touch();
      if (this.$v.formData.$anyError) {
        return;
      }
      this.loader(true);
      let data = { ...this.formData, integration_id: this.integration_id };
      Apiservice.post("/validations/supplierMapping/update", data)
        .then(() => {
          Swal.fire({
            title: "Updated",
            text: "The Supplier Data has been Updated",
            icon: "success",
            showConfirmButton: false,
            timer: 2500,
          });
          this.toggleModal();
          this.refresher();
        })
        .catch(() => {
          this.loader(false);
        });
    },
    resetForm() {
      this.formData.supplier_id = this.itemForAction.id;
      this.formData.supplier = this.itemForAction.supplier;
      this.formData.system_code = this.itemForAction.systemCode;
      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
  },
};
</script>
